/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Table, Tag, Button, Input, Select, Space, Modal, Card, Typography, message, Tooltip } from 'antd';
import {
  SearchOutlined,
  CheckCircleOutlined,
  StopOutlined,
  StarOutlined,
  StarFilled,
  EyeOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { getAuthHeaders } from './jobManagementUtils';
import './JobManagement.css';

const { Text, Paragraph } = Typography;
const { Option } = Select;

function JobPostManagement(props) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [provinceFilter, setProvinceFilter] = useState('ทั้งหมด');
  const [previewJob, setPreviewJob] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const authHeaders = getAuthHeaders(props.permitdata?.token);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        (props.app_hostname || '') + '/api/market/management/jobs/posts',
        {
          status: statusFilter,
          province: provinceFilter,
        },
        { headers: authHeaders }
      );
      if (res.data && res.data.status === 'Success') {
        setData(res.data.data?.items || []);
      }
    } catch (err) {
      message.error('ไม่สามารถดึงข้อมูลประกาศงานได้');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, [statusFilter, provinceFilter]);

  const handleToggleFeatured = async (record) => {
    const nextFeatured = !record.is_featured;
    try {
      await axios.post(
        (props.app_hostname || '') + '/api/market/management/jobs/post_status',
        {
          post_id: record.id,
          status: record.status,
          is_featured: nextFeatured,
        },
        { headers: authHeaders }
      );
      setData((prev) =>
        prev.map((item) => (item.id === record.id ? { ...item, is_featured: nextFeatured } : item))
      );
      message.success(nextFeatured ? 'ปักหมุด Featured Job 🌟 เรียบร้อยแล้ว' : 'ยกเลิก Featured Job');
    } catch (err) {
      message.error('เกิดข้อผิดพลาดในการปรับสถานะ');
    }
  };

  const handleStatusChange = async (postId, newStatus) => {
    try {
      await axios.post(
        (props.app_hostname || '') + '/api/market/management/jobs/post_status',
        {
          post_id: postId,
          status: newStatus,
        },
        { headers: authHeaders }
      );
      setData((prev) =>
        prev.map((item) => (item.id === postId ? { ...item, status: newStatus } : item))
      );
      message.success('ปรับปรุงสถานะประกาศงานเรียบร้อยแล้ว');
    } catch (err) {
      message.error('เกิดข้อผิดพลาดในการปรับสถานะ');
    }
  };

  const filteredData = data.filter((item) => {
    const matchSearch =
      !searchText ||
      item.title?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.company_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.category_name?.toLowerCase().includes(searchText.toLowerCase());
    return matchSearch;
  });

  const columns = [
    {
      title: 'ตำแหน่งงาน',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 600, color: '#1890ff', fontSize: 14 }}>{text}</div>
          <div style={{ fontSize: 12, color: '#8c8c8c' }}>{record.company_name}</div>
          {record.is_featured && <Tag color='gold' style={{ marginTop: 4 }}>🌟 Featured Job</Tag>}
        </div>
      ),
    },
    {
      title: 'วิชาชีพ',
      dataIndex: 'category_name',
      key: 'category_name',
      render: (cat) => <Tag color='geekblue'>{cat || 'ไม่ระบุ'}</Tag>,
    },
    {
      title: 'จังหวัด',
      dataIndex: 'province',
      key: 'province',
      render: (prov) => <Tag color='cyan'>{prov || 'ไม่ระบุ'}</Tag>,
    },
    {
      title: 'เงินเดือน',
      dataIndex: 'salary_text',
      key: 'salary_text',
      render: (salary) => <span style={{ fontWeight: 500, color: '#389e0d' }}>{salary || 'ตามตกลง'}</span>,
    },
    {
      title: 'ประเภทงาน',
      dataIndex: 'job_type',
      key: 'job_type',
    },
    {
      title: 'สถานะประกาศ',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        if (status === 'active') return <Tag color='success'>เผยแพร่อยู่ (Active)</Tag>;
        if (status === 'suspended') return <Tag color='error'>ระงับ (Suspended)</Tag>;
        return <Tag color='warning'>รอการตรวจสอบ</Tag>;
      },
    },
    {
      title: 'ยอดเข้าชม',
      dataIndex: 'view_count',
      key: 'view_count',
      render: (count) => (count ? count.toLocaleString() : 0),
    },
    {
      title: 'จัดการ & ตรวจสอบ',
      key: 'actions',
      render: (_, record) => (
        <Space size='small'>
          <Tooltip title='ดูตัวอย่างประกาศ'>
            <Button
              size='small'
              icon={<EyeOutlined />}
              onClick={() => {
                setPreviewJob(record);
                setIsPreviewOpen(true);
              }}
            />
          </Tooltip>

          <Tooltip title={record.is_featured ? 'ยกเลิก Featured' : 'ปักหมุด Featured'}>
            <Button
              size='small'
              type={record.is_featured ? 'primary' : 'default'}
              icon={record.is_featured ? <StarFilled style={{ color: '#faad14' }} /> : <StarOutlined />}
              onClick={() => handleToggleFeatured(record)}
            />
          </Tooltip>

          {record.status !== 'active' ? (
            <Button
              size='small'
              icon={<CheckCircleOutlined />}
              onClick={() => handleStatusChange(record.id, 'active')}
              type='text'
              style={{ color: '#52c41a' }}
            >
              อนุมัติ
            </Button>
          ) : (
            <Button
              size='small'
              danger
              icon={<StopOutlined />}
              onClick={() => handleStatusChange(record.id, 'suspended')}
              type='text'
            >
              ระงับ
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className='job-management-container'>
      <div className='job-management-header'>
        <div>
          <h2>📋 จัดการประกาศงาน (Job Post Moderation)</h2>
          <Text type='secondary'>
            ดึงข้อมูลประกาศงานจริงจากฐานข้อมูล ({data.length} รายการ) ตรวจสอบความถูกต้อง อนุมัติ และตั้งค่างานเด่น (Featured Jobs)
          </Text>
        </div>
        <Button icon={<ReloadOutlined />} onClick={fetchPosts}>
          รีเฟรช
        </Button>
      </div>

      <Card className='job-management-card'>
        <div className='job-filter-bar'>
          <Input
            placeholder='ค้นหาตำแหน่งงาน, สถานประกอบการ...'
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 280 }}
            allowClear
          />
          <Select value={statusFilter} onChange={setStatusFilter} style={{ width: 160 }}>
            <Option value='all'>สถานะทั้งหมด</Option>
            <Option value='active'>เปิดรับสมัคร (Active)</Option>
            <Option value='pending_review'>รอตรวจสอบ (Pending)</Option>
            <Option value='suspended'>ระงับ (Suspended)</Option>
          </Select>
        </div>

        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey='id'
          loading={loading}
          pagination={{ pageSize: 10, showTotal: (total) => `รวม ${total} ประกาศ` }}
        />
      </Card>

      {/* Modal ดูตัวอย่างประกาศงาน */}
      <Modal
        title='ตัวอย่างประกาศรับสมัครงาน'
        open={isPreviewOpen}
        onCancel={() => setIsPreviewOpen(false)}
        footer={[
          <Button key='close' onClick={() => setIsPreviewOpen(false)}>
            ปิด
          </Button>,
        ]}
        width={650}
      >
        {previewJob && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <h3 style={{ margin: 0, color: '#1890ff' }}>{previewJob.title}</h3>
              <Text strong>{previewJob.company_name}</Text>
            </div>

            <Space wrap orientation='horizontal'>
              <Tag color='geekblue'>{previewJob.category_name}</Tag>
              <Tag color='cyan'>{previewJob.province}</Tag>
              <Tag color='purple'>{previewJob.job_type}</Tag>
              <Tag color='green'>{previewJob.salary_text}</Tag>
            </Space>

            <div>
              <Text strong>รายละเอียดงาน:</Text>
              <Paragraph style={{ marginTop: 4, background: '#f5f5f5', padding: 8, borderRadius: 6 }}>
                {previewJob.description || 'ไม่มีรายละเอียดเพิ่มเติม'}
              </Paragraph>
            </div>

            <div>
              <Text strong>คุณสมบัติผู้สมัคร:</Text>
              <Paragraph style={{ marginTop: 4, background: '#f5f5f5', padding: 8, borderRadius: 6 }}>
                {previewJob.requirements || 'ไม่มีคุณสมบัติเฉพาะระบุ'}
              </Paragraph>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default JobPostManagement;
